import { GetWorkScheduleSlotItemResponse } from '@/hooks/queries/use-get-office-work-schedules-slots';
import { doctorFullnameTitleTrad } from '@/utils/doctor';

/**
 * View model of the read-only work-schedule slot sheet shown to substitutes:
 * when the attending doctor is working. Their contact details are deliberately
 * left out — substitutes go through the office, not the doctor directly.
 *
 * @param params.slot - The work-schedule slot that was clicked.
 * @returns The sheet title and the slot information.
 */
export const selectViewUserWorkScheduleSlotSheetViewModel = ({
  slot,
}: {
  slot: GetWorkScheduleSlotItemResponse;
}) => {
  return {
    title: doctorFullnameTitleTrad(slot.doctorAttending),
    information: {
      slotType: slot.slotType,
    },
  };
};
